import Vue from 'vue'
import VueSwal from 'vue-swal'

Vue.use(VueSwal)

Vue.mixin({
  methods: {
    alertConfirmRemove(callback) {
      return this.$swal({
        text: 'Tem certeza que deseja remover?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Não',
            value: null,
            visible: true,
            className: 'v-btn v-btn--router theme--light',
            closeModal: true
          },
          confirm: {
            text: 'Sim',
            value: true,
            visible: true,
            className: 'v-btn v-btn--router theme--light success',
            closeModal: true
          }
        }
      }).then((result) => {
        if (result) {
          return callback()
        }
        return false
      }).then((result) => {
        if (result !== false) {
          this.$swal(
            'Removido!',
            'Registro removido com sucesso.',
            'success'
          )
        }
      }).catch(err => {
        console.log(err)
        this.$swal(
          'Ops!',
          'Ocorreu um erro. Contate o administrador do sistema.',
          'error'
        )
      })
    }
  }
})
